import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["innerHTML"]

import Product from '@/classes/Product';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductCardRecommendation',
  props: {
    product: {},
    isSingle: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["product-card__recommendation", {
        filled: _ctx.product.getRecommendationText(_ctx.isSingle),
      }]),
    "data-eq-part": "product-product-card__recommendation"
  }, [
    (_ctx.product.getRecommendationText(_ctx.isSingle))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          innerHTML: _ctx.product.getRecommendationText(_ctx.isSingle)
        }, null, 8, _hoisted_1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})